import axios from "axios";
import {TTP_API_URL} from "Config";
import { updateSourceToken, throwCatchedError } from 'utils';

let fetchAssignmentsSourceToken;

export const fetchAssignments = ({token, params = {}, operationTypes, sourceToken=null}) => {

  fetchAssignmentsSourceToken = updateSourceToken(fetchAssignmentsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/assignment`;

  var sortedProps = [];

  // if(operationTypes.length !== 0 && operationTypes.indexOf("BANK_TRANSFER") != -1) {
  //   sortedProps = [{property: "bankTransferSequenceNumber", dir: "ASC"}];
  //
  // } else {
  //   sortedProps = [{property: "createdAt", dir: "desc"}];
  //
  // }

  sortedProps = [{property: "dateTimeAssignment", dir: "desc"}];

  const sort = params.sort ? params.sort : sortedProps;

  const filter = params.filter ? params.filter : [];
  const start = params.start ? params.start : 0;
  const limit = params.limit ? params.limit : 10;

  return axios.get(requestUrl, {
    cancelToken: fetchAssignmentsSourceToken.token,
    params: {
      access_token: token,
      fields: "*,operation,document",
      sort: JSON.stringify(sort),
      filter: JSON.stringify(filter),
      start,
      limit
    }
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const fetchAssignmentOtherFilters = ({token, codaFiles}) => {

  const requestUrl = `${TTP_API_URL}/billing/assignment/other-filters-group-list`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      codaFiles: codaFiles,
    }
  });
};


export const getPaymentsStats = (token, dates, issuerId , associationStatus , iban, codaFiles, app, appRef) => {

  const requestUrl = `${TTP_API_URL}/billing/assignment/sum-amount-by-filter-data`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      dates,
      issuerId,
      associationStatus,
      iban,
      codaFiles,
      app,
      appRef
    }
  })
};

let fetchOrganizationIbanSourceToken;

export const fetchOrganizationIban = (token, issuerId, period, sourceToken) => {

  fetchOrganizationIbanSourceToken = updateSourceToken(fetchOrganizationIbanSourceToken, sourceToken);
  const requestUrl = TTP_API_URL+`/billing/assignment/get-organization-ibans`;

  return axios.get(requestUrl, {
    cancelToken: fetchOrganizationIbanSourceToken.token,
    params: {
      access_token: token,
      issuerId,
      period,
    }
  });
};


export const getMissingSequenceNumberByAccount = (token,issuerId, period, account) => {

  const requestUrl = `${TTP_API_URL}/billing/assignment/get-missing-sequence-number-by-account`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      issuerId,
      period,
      account,
    }
  })
};

export const getAssignmentMissingSequenceNumberByAccount = (token,issuerId, period, account) => {

  const requestUrl = `${TTP_API_URL}/billing/assignment/get-assignment-missing-sequence-number-by-account`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      issuerId,
      period,
      account,
    }
  })
};

export const getOrganizationBalance = (token,issuerId, year, account) => {

  const requestUrl = `${TTP_API_URL}/billing/coda-file/get-account-balance`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      issuerId,
      year,
      account,
    }
  })
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/assignments.js